<template lang="html">
  <div class="video-component__player-wrapper"
    v-lazy:background-image="video_thumbnail"
    role="img"
    :aria-label="`Video: ${video_title}`">
    <div class="video-component__thumbnail">
      <button
        @click="openVideo"
        aria-label="play button"
        class="video-component__play-btn">
        <slot name="play-button"></slot>
      </button>
    </div>
    <Modal class="video-modal" ref="video" v-if="video_url">
      <template slot="content">
        <iframe id="video-component__player-embed" :src="youtubeEmbedLink" title="Video Player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen v-if="youtubeVideo"></iframe>
        <iframe id="video-component__player-embed" :src="vimeoEmbedLink" frameborder="0" v-if="vimeoVideo"></iframe>
      </template>
    </Modal>
  </div>
</template>

<script>
  import Modal from 'scripts/components/basic/Modal.vue';

  export default {
    name: 'VideoComponent',
    components: {
      Modal
    },
    props: {
      video_url: {
        type: String,
        required: true
      },
      video_type: {
        type: String,
        required: true
      },
      video_id: {
        type: String
      },
      video_thumbnail: {
        type: String,
        required: true
      },
      video_title: {
        type: String,
      },
    },
    data() {
      return {}
    },
    computed: {
      youtubeVideo() {
        return this.video_type === 'youtube';
      },
      youtubeEmbedLink() {
        if (this.video_type !== 'youtube') return false;
        return `https://www.youtube.com/embed/${this.video_id}?autoplay=1`;
      },
      vimeoVideo() {
        return this.video_type === 'vimeo';
      },
      vimeoEmbedLink() {
        if (this.video_type !== 'vimeo') return false;
        return `https://player.vimeo.com/video/${this.video_id}?portrait=0&byline=0`;
      }
    },
    mounted() {},
    methods: {
      openVideo() {
        this.$refs.video.open();
      }
    }
  }
</script>
